import React, {useState, useEffect, useContext} from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import AdminNavbar from '../components/AdminNavbar';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { Box, Button, Container } from '@mui/material';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import InfoIcon from '@mui/icons-material/Info';
import TextField from '@mui/material/TextField';


import { collection, getDoc, updateDoc,getDocs, doc } from 'firebase/firestore';
import { auth, db, logMe } from '../firebase';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import AlertsContext from '../AlertsContext';
import { useAuthState } from 'react-firebase-hooks/auth';
import TimeSlotSelector, { checkSlotAvailable, useSlotsInfo } from '../components/TimeSlots';
import { defaultEndTime, defaultMaxGroups, defaultMaxPeople, defaultMaxPeoplePerLocation, defaultSlotSize, defaultStartTime } from 'shared';
import { useLocations } from '../components/LocationSelect';
import dayjs from 'dayjs';
import { format } from 'date-fns';
import { convertTimeZone, getCalendarOverwrites, parseDateAndTime } from '../helpers';
import { zonedTimeToUtc, formatInTimeZone, utcToZonedTime } from 'date-fns-tz';

function EditPurchase() {
    const navigate = useNavigate();
    const {id} = useParams()
    const [purchase, setPurchase] = useState();
    const [ticketLocation, setTicketLocation] = useState();
    const [tickets, setTickets] = useState([]);
    const { setAlert } = useContext(AlertsContext);
    const purchaseRef = doc(db, `ticketPurchases/${id}`);
    const [user] = useAuthState(auth);
    const locations = useLocations();
    const [selectedTime, setSelectedTime] = useState();
    const [selectedDate, setSelectedDate] = useState();
    const [dayOfWeek, setDayOfWeek] = useState();
    const {slotsInfo} = useSlotsInfo(ticketLocation, selectedDate);
    const [overwrites, setOverwrites] = useState([]);
    const [disabledDates, setDisabledDates] = useState([]);

    const [disabledTimes, setDisabledTimes] = useState([]);
    useEffect(() => {
      // loops over all times and if the groups or groupSize is greater than the max, it adds it to the disabled times
      const disabledTimes = [];
      for(const time in slotsInfo) {
        if(slotsInfo[time].groups + 1 > defaultMaxGroups
          || slotsInfo[time].groupSize + tickets?.length > (defaultMaxPeoplePerLocation[ticketLocation.id] || defaultMaxPeople))
          disabledTimes.push(time);
      }
      setDisabledTimes(disabledTimes);
    }, [slotsInfo, tickets, ticketLocation])



    async function getTickets(db) {
        const ticketsCol = collection(db, `ticketPurchases/${id}/tickets`);
        const ticketsSnapshot = await getDocs(ticketsCol);
        const ticketsList = ticketsSnapshot.docs.map(doc => doc.data());
        return ticketsList;
    }

    // function setTicketDate(ticketID, newDate) {
    //     const ticketRef = doc(db, `ticketPurchases/${id}/tickets/${ticketID}`);
    //     updateDoc(ticketRef, {
    //         startDate: newDate.toDate(),
    //     });
    //     setAlert("Ticket updated successfully!")
    //     refreshTickets();
    // } 

    function setAllTicketDates(newDate) {
        tickets.forEach(ticket => {
            const ticketRef = doc(db, `ticketPurchases/${id}/tickets/${ticket.ticketID}`);
            updateDoc(ticketRef, {
                startDate: newDate,
                selectedDateTime: newDate,
            });
            const emailRef = doc(db, `emails/${id}`);
            updateDoc(emailRef, {
                "dynamicTemplateData.date": formatInTimeZone(newDate, ticketLocation.timeZone, 'PPPP'),
                "dynamicTemplateData.time": formatInTimeZone(newDate, ticketLocation.timeZone, 'HH:mm'),
            });
        });
        refreshTickets();
    }

    useEffect(() => {
        if(!locations.length) 
            return;
        // get a purchase doc
        getDoc(purchaseRef).then(async (doc) => {
            if (doc.exists()) {
                const data = doc.data();
                setPurchase(data)

                const selectedDateTime = data.selectedDateTime?.toDate() || new Date(new Date().setMinutes(0, 0, 0));

                setDayOfWeek(format(selectedDateTime, 'EEEE').toLowerCase());  
                const loc = locations.find(l => l.id === data.ticketLocation);
                setSelectedDate(selectedDateTime);
                setTicketLocation(loc);
                
                refreshTickets();

                const overwritesResponse = await getCalendarOverwrites(loc.id, true);
                setOverwrites(overwritesResponse);
                setDisabledDates(overwritesResponse.filter(d => d.blocked));
                
            } else {
                // doc.data() will be undefined in this case
                console.log("No such purchase!");
            }
        });
    }, [locations]);

    async function refreshTickets() {
        // get tickets 
        const tickets = await getTickets(db);
        setTickets(tickets);
    }
    
    function handleRedeem(ticketID) {
        if(!window.confirm("Are you sure you want to redeem this ticket?")) return;
        const ticketRef = doc(db, `ticketPurchases/${id}/tickets/${ticketID}`);
        updateDoc(ticketRef, {
            status: "used",
        });
        setAlert("Ticket redeemed successfully!")
        setTickets(tickets.map(ticket => 
            ticket.ticketID !== ticketID ? ticket : {...ticket, status: "used"}
        ));
    }
    const [checkingAvailability, setCheckingAvailability] = useState(false);

    async function updatePurchase() {
        setCheckingAvailability(true);
        // check if the time slot is available
        let isAvailable;
        try {
            isAvailable = await checkSlotAvailable(ticketLocation, dayjs(selectedDate), selectedTime, tickets.length);
        } catch {
            setCheckingAvailability(false);
            setAlert({ type: "error", message: "We couldn’t check availability. Your selection is saved. Please try again." });
            return;
        }
        setCheckingAvailability(false);
        if(!isAvailable) {
            setAlert({
            type:"error",
            message: "Sorry, this time slot is no longer available. Please choose a different time."
            }); 
            return;
        }

        setAllTicketDates(selectedDate)
        updateDoc(purchaseRef, {
            selectedDateTime: selectedDate
        });
        setAlert("Purchase updated successfully!")
        setSelectedTime();
    }

    const [canEdit, setCanEdit] = useState(false);
    useEffect(() => {
        if(!purchase) return;
        // Allow admin edit, legacy tickets, or tickets with 24 hours before expiry
        setCanEdit(user || !purchase.selectedDateTime || purchase.selectedDateTime?.toDate().getTime() - 24*60*60*1000 > new Date().getTime())
    }, [user, purchase]);

    const customHours = overwrites.find(d => d.date === dayjs(selectedDate)?.format('YYYY-MM-DD') && d.time);

    return (
        <>
        <AdminNavbar />
            {/* <Button color="inherit" variant="text" onClick={() => navigate(-1)}>Go Back</Button> */}
            <Container maxWidth="xs" sx={{textAlign: 'center'}}>
                {tickets.length === 0 ? 
                (<h2>Loading...</h2>) : (
                <>
                <h2>Edit Purchase</h2>
                    <ListItem sx={{mt:2, alignItems: 'center', justifyContent: 'center'}}>
                        <ListItemAvatar>
                        <Avatar>
                            <CalendarMonthIcon />
                        </Avatar>
                        </ListItemAvatar>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <MobileDatePicker
                                closeOnSelect={true}
                                label="Entry Date & Time"
                                inputFormat="DD-MM-YYYY HH:mm"
                                disablePast
                                // give 24 hours before expiry date to update
                                // unless the user is logged in (admin), in which case they can update at any time
                                // use the first ticket as reference
                                disabled={!canEdit}
                                // dayjs(tickets[0].startDate.toDate())
                                value={convertTimeZone(selectedDate, ticketLocation.timeZone)}
                                onChange={(newDate) => {
                                    // reset selected time
                                    setSelectedTime();
                                    setSelectedDate(convertTimeZone(newDate.toDate(), Intl.DateTimeFormat().resolvedOptions().timeZone, ticketLocation.timeZone))
                                    
                                }}
                                shouldDisableDate={(date) => {
                                    return disabledDates.some((d) => d.date === date.format('YYYY-MM-DD'));
                                  }}
                                renderInput={(params) => <TextField {...params} />}
                            />
                        </LocalizationProvider>
                    </ListItem>

                    {canEdit && selectedDate && <TimeSlotSelector
                        startTime={customHours?.time?.from || ticketLocation?.hours?.[dayOfWeek]?.from || defaultStartTime} 
                        endTime={customHours?.time?.to || ticketLocation?.hours?.[dayOfWeek]?.to || defaultEndTime} 
                        slotSize={defaultSlotSize} 
                        selectedTime={selectedTime} 
                        setSelectedTime={(time) => {
                            setSelectedDate(parseDateAndTime(dayjs(selectedDate), time, ticketLocation.timeZone));
                            setSelectedTime(time);
                        }} 
                        selectedDate={dayjs(selectedDate)}
                        disabledTimes={disabledTimes}
                        />
                    }

                    {canEdit && <Button disabled={!selectedDate || !selectedTime || checkingAvailability} size="large" sx={{my: 2, width: '100%'}} variant="contained" onClick={updatePurchase}>UPDATE</Button>}

                    {tickets.map(ticket =>           
                        <List key={ticket.ticketID} sx={{ width:'100%', bgcolor: 'background.paper', boxShadow: 2, margin: '0 auto', marginTop:2, alignItems:'center' }}>
                            <ListItem>
                            <ListItemAvatar>
                            <Avatar>
                                <ConfirmationNumberIcon />
                            </Avatar>
                            </ListItemAvatar>
                            <ListItemText primary={ticket.title} />
                        </ListItem>
                        {/* Disabled for now */}
                        {/* <ListItem>
                            <ListItemAvatar>
                            <Avatar>
                                <CalendarMonthIcon />
                            </Avatar>
                            </ListItemAvatar>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <MobileDatePicker
                                    label="Expiry Date"
                                    inputFormat="DD-MM-YYYY"
                                    disablePast
                                    // give 24 hours before expiry date to update
                                    // unless the user is logged in (admin), in which case they can update at any time
                                    disabled={!user && ticket.startDate.toDate().getTime() + 24*60*60*1000 < new Date().getTime()}
                                    value={ticket.startDate.toDate()}
                                    onChange={(newDate) => setTicketDate(ticket.ticketID, newDate)}
                                    renderInput={(params) => <TextField {...params} />}
                                />
                            </LocalizationProvider>
                        </ListItem> */}
                        <ListItem>
                            <ListItemAvatar>
                            <Avatar>
                                <InfoIcon />
                            </Avatar>
                            </ListItemAvatar>
                            <ListItemText primary={ticket.status.toUpperCase()} />
                        </ListItem>
                        <ListItem>
                            {user && ticket.status === "paid" && <Button onClick={() => handleRedeem(ticket.ticketID)}>Redeem</Button>}
                        </ListItem>
                        </List>
                    )}
                </>
            )}
        </Container>
        </>
    );
}

export default EditPurchase;